import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonService } from 'src/app/shared/services/common.service';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-edit-referee',
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule, ReactiveFormsModule],
  templateUrl: './edit-referee.component.html',
  styleUrl: './edit-referee.component.scss'
})
export class EditRefereeComponent {
  refereeForm: FormGroup;
  constructor(
    private commonService: CommonService,
    private fb: FormBuilder,
    private toastService: ToastService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<EditRefereeComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.refereeForm = this.fb.group({
      name: [''],
      phoneNumber: [''],
      email: ['']
    })
  }

  submit(){
    alert('Data submitted successfully')
  }
}
